import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  FaChartLine,
  FaShieldAlt,
  FaHeadset,
  FaTrophy,
  FaGraduationCap,
  FaBriefcase,
} from "react-icons/fa";

const LeadershipCard = ({ leader, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
    >
      <Card className="h-100 leadership-card">
        <Card.Body className="text-center">
          <div className="leadership-icon mb-3">{leader.icon}</div>
          <h4 className="mb-2">{leader.name}</h4>
          <h6 className="text-primary mb-3">{leader.title}</h6>
          <p className="text-muted mb-4">{leader.description}</p>

          <div className="leadership-stats">
            <Row>
              <Col xs={6}>
                <div className="stat-item">
                  <div className="stat-icon">
                    <FaBriefcase className="text-success" />
                  </div>
                  <div className="stat-number">{leader.experience}</div>
                  <div className="stat-label">Years Experience</div>
                </div>
              </Col>
              <Col xs={6}>
                <div className="stat-item">
                  <div className="stat-icon">
                    <FaGraduationCap className="text-info" />
                  </div>
                  <div className="stat-number">{leader.education}</div>
                  <div className="stat-label">Education</div>
                </div>
              </Col>
            </Row>

            <div className="leadership-achievements mt-3">
              <h6 className="mb-2">Key Achievements</h6>
              <ul className="achievements-list ps-0">
                {leader.achievements.map((achievement, idx) => (
                  <li key={idx} className="mb-1 d-flex align-items-center">
                    <FaTrophy className="text-warning me-2" size={12} />
                    <span className="small">{achievement}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Card.Body>
      </Card>
    </motion.div>
  );
};

const Leadership = () => {
  const leaders = [
    {
      name: "Michael Rodriguez",
      title: "Trading Director",
      icon: <FaChartLine size={48} className="text-primary" />,
      description:
        "Leading our advanced trading operations with institutional-grade strategies and risk management protocols.",
      experience: "15+",
      education: "MBA Finance",
      achievements: [
        "37% average monthly returns",
        "Risk-adjusted Sharpe ratio of 2.8",
        "Managed $500M+ in assets",
      ],
    },
    {
      name: "Sarah Chen",
      title: "Head of Compliance",
      icon: <FaShieldAlt size={48} className="text-success" />,
      description:
        "Ensuring regulatory excellence and maintaining the highest standards of compliance across all jurisdictions.",
      experience: "30+",
      education: "JD Law",
      achievements: [
        "30+ years of regulatory experience",
        "Zero regulatory violations",
        "Cryptocurrency law expert",
      ],
    },
    {
      name: "David Thompson",
      title: "VP of Client Services",
      icon: <FaHeadset size={48} className="text-info" />,
      description:
        "Delivering exceptional client experiences and building long-term relationships with our institutional partners.",
      experience: "10+",
      education: "MS Economics",
      achievements: [
        "98% client satisfaction rate",
        "Managed 200+ institutional accounts",
        "Former Big Company relationship manager",
        "Multi-lingual support expertise",
      ],
    },
  ];

  return (
    <section className="leadership-section py-5">
      <Container>
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={7}>
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="fw-bold mb-3">Leadership Team</h2>
              <p className="text-muted">
                Meet our experienced leadership team with over 50 years of
                combined trading experience and expertise in cryptocurrency
                markets, regulatory compliance, and institutional client
                services.
              </p>
            </motion.div>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center">
          {leaders.map((leader, index) => (
            <Col key={leader.name} md={6} lg={4}>
              <LeadershipCard leader={leader} index={index} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Leadership;
